import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "membership-hub my-scroller"
};
const _hoisted_2 = {
  class: "membership-hub-header"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "membership-hub-body"
};
const _hoisted_5 = {
  class: "service-item-name"
};
const _hoisted_6 = {
  class: "service-item-tips"
};
const _hoisted_7 = {
  class: "service-item-details"
};
const _hoisted_8 = {
  class: "payment-decorate"
};
const _hoisted_9 = {
  key: 0,
  class: "payment-type"
};
const _hoisted_10 = {
  key: 1,
  class: "payment-method"
};
const _hoisted_11 = {
  class: "payment-method-box"
};
const _hoisted_12 = {
  class: "payment-method-code"
};
const _hoisted_13 = {
  key: 2
};
const _hoisted_14 = {
  key: 3,
  class: "points-payment"
};
const _hoisted_15 = {
  class: "points-info"
};
const _hoisted_16 = {
  class: "code-bg",
  style: {
    "text-align": "right"
  }
};
import { ref, onUnmounted, computed } from 'vue';
import vipPurchase from './components/vipPurchase.vue';
import benefitsPurchase from './components/benefitsPurchase.vue';
import { getAppProductPackagePage, createPointPayOrder } from '@/request/equity';
import usePayment from '@/hooks/usePayment.ts';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import { useMainStore } from '@/pinia';
import { copyText, debounce } from '@/utils/index.ts';
export default /*@__PURE__*/_defineComponent({
  __name: 'membershipHub',
  emits: ['paymentStatusChange'],
  setup(__props, {
    emit: __emit
  }) {
    const store = useMainStore();
    // 用户账户下次
    let amountInfo = computed(() => store.amountInfo);
    const emit = __emit;
    const kfVisible = ref(false);
    let serviceTabs = ref([{
      name: '套餐购买',
      key: 'vipPurchase',
      tips: '全场景数字人套餐，带你步入梦幻科技世界。',
      label: '超值套餐，梦幻开启'
    },
    // { name: '权益购买', key: 'benefitsPurchase', tips: '入手权益，尽情畅享 AI 精彩盛宴。', label: '权益盛宴，畅享 AI' },
    {
      name: '积分购买',
      key: 'pointsPurchase',
      label: '速抢积分额度包，积分开启数字奇妙之旅',
      tips: '积分在手，数字人克隆、直播、视频、对话全功能轻松畅享，精彩即刻开启。'
    }]);
    const getComponentName = key => {
      switch (key) {
        case 'vipPurchase':
          return vipPurchase;
        case 'pointsPurchase':
          return benefitsPurchase;
        default:
          return null;
      }
    };
    const scrollToItem = itemNumber => {
      const itemRef = ref(null);
      itemRef.value = document.querySelector(`.service-item:nth-child(${itemNumber})`);
      if (itemRef.value) {
        itemRef.value.scrollIntoView({
          behavior: 'smooth'
        });
      }
    };
    // 套餐列表
    const packageList = ref([]);
    const getAppProductPackagePageFn = async (params = {
      pageIndex: 1,
      pageSize: 10,
      keyword: ''
    }) => {
      const res = await getAppProductPackagePage(params);
      let {
        code,
        data,
        msg
      } = res.data;
      if (code === 200) {
        packageList.value = data.list;
      }
    };
    getAppProductPackagePageFn();
    // 支付弹窗
    let paymentShow = ref(false);
    let buyData = ref(null);
    let codeImg = ref(null);
    const {
      createOrder,
      watchOrderStatus,
      clearTimer,
      closePayment
    } = usePayment();
    onUnmounted(() => {
      closePayment();
    });
    const getPurchase = debounce(async (i, type = '') => {
      if (i.buyType === "custom") {
        kfVisible.value = true;
        return;
      }
      try {
        const baseParams = {
          amount: i.amount
        };
        const buyDataMap = {
          ...i
        };
        // 根据 buyType 设置支付方式
        switch (i.buyType) {
          case 1:
            buyDataMap.paymentMethods = ['wxpay'];
            break;
          case 2:
            buyDataMap.paymentMethods = ['points'];
            break;
          case 3:
            buyDataMap.paymentMethods = ['wxpay', 'points'];
            break;
          default:
            buyDataMap.paymentMethods = ['wxpay'];
        }
        // 设置默认支付方式
        paymentType.value = buyDataMap.paymentMethods[0];
        let params = {};
        if (type === 'vipPurchase') {
          params = {
            ...baseParams,
            businessId: i.id,
            businessType: '形象音色定制'
          };
          buyDataMap.bugLabel = i.name;
        } else {
          params = {
            ...baseParams,
            businessType: '积分'
          };
          buyDataMap.bugLabel = i.buyLabel;
        }
        buyDataMap.buyMoney = i.amount / 100;
        buyData.value = buyDataMap;
        // 只有当支付方式包含微信支付时才获取支付二维码
        if (buyDataMap.paymentMethods.includes('wxpay')) {
          const orderData = await createOrder(params);
          codeImg.value = orderData.codeUrl;
          // 显示支付弹窗
          paymentShow.value = true;
          // 监听支付状态
          await watchOrderStatus(orderData.orderPaymentId, {
            onSuccess: () => {
              ElMessage.success('支付成功');
              paymentShow.value = false;
              emit('paymentStatusChange', {
                status: 'success'
              });
            },
            onFailed: error => {
              ElMessage.error('支付失败：' + error.message);
              paymentShow.value = false;
              emit('paymentStatusChange', {
                status: 'failed',
                error: error.message
              });
            },
            onPending: () => {
              console.log('等待支付中...');
              emit('paymentStatusChange', {
                status: 'pending'
              });
            }
          });
        } else {
          // 如果不包含微信支付，直接显示支付弹窗
          paymentShow.value = true;
        }
      } catch (error) {
        console.error('支付过程出错:', error);
      }
    }, 300);
    // 添加新的响应式变量
    const paymentType = ref('wxpay'); // 支付方式：wxpay 或 points
    // 处理分支付
    // 修改支付处理函数，添加防抖
    const handlePointsPayment = debounce(async () => {
      try {
        const res = await createPointPayOrder({
          businessType: '形象音色定制',
          businessId: buyData.value.id
        });
        let {
          code,
          data,
          msg
        } = res.data;
        if (code === 200) {
          ElMessage.success('支付成功');
          paymentShow.value = false;
          await store.getAppUserAmountInfoFn();
          emit('paymentStatusChange', {
            status: 'success'
          });
        } else {
          emit('paymentStatusChange', {
            status: 'failed',
            error: msg
          });
        }
      } catch (error) {
        console.error("支付失败", error);
        emit('paymentStatusChange', {
          status: 'failed',
          error: error.message
        });
      } finally {
        paymentShow.value = false;
      }
    }, 300);
    return (_ctx, _cache) => {
      const _component_vue_qrcode = _resolveComponent("vue-qrcode");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(serviceTabs), (tab, index) => {
        return _openBlock(), _createElementBlock("div", {
          onClick: $event => scrollToItem(index + 1),
          class: "header-item",
          key: index
        }, _toDisplayString(tab.name), 9, _hoisted_3);
      }), 128))]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(serviceTabs), item => {
        return _openBlock(), _createElementBlock("div", {
          class: "service-item",
          key: item,
          ref_for: true,
          ref: 'item' + item.key
        }, [_createElementVNode("div", _hoisted_5, [_createTextVNode(_toDisplayString(item.label) + " ", 1), _createElementVNode("span", _hoisted_6, _toDisplayString(item.tips), 1)]), _createElementVNode("div", _hoisted_7, [(_openBlock(), _createBlock(_resolveDynamicComponent(getComponentName(item.key)), {
          type: item.key,
          packageList: packageList.value,
          onPurchase: _unref(getPurchase)
        }, null, 40, ["type", "packageList", "onPurchase"]))])]);
      }), 128))]), _createVNode(_component_el_dialog, {
        modelValue: _unref(paymentShow),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(paymentShow) ? paymentShow.value = $event : paymentShow = $event),
        title: "购买支付",
        onClose: _unref(closePayment),
        center: "",
        width: "500",
        style: {
          'border-radius': '20px',
          'background': '#f4f8ff'
        },
        showClose: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("h1", null, _toDisplayString(_unref(buyData).bugLabel), 1), _unref(buyData).paymentMethods && _unref(buyData).paymentMethods.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_unref(buyData).paymentMethods.includes('wxpay') ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["type-item", {
            active: paymentType.value === 'wxpay'
          }]),
          onClick: _cache[0] || (_cache[0] = $event => paymentType.value = 'wxpay')
        }, _cache[5] || (_cache[5] = [_createElementVNode("i", {
          class: "ri-wechat-pay-fill"
        }, null, -1), _createElementVNode("span", null, "微信支付", -1)]), 2)) : _createCommentVNode("", true), _unref(buyData).paymentMethods.includes('points') ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["type-item", {
            active: paymentType.value === 'points'
          }]),
          onClick: _cache[1] || (_cache[1] = $event => paymentType.value = 'points')
        }, _cache[6] || (_cache[6] = [_createElementVNode("i", {
          class: "ri-coins-fill"
        }, null, -1), _createElementVNode("span", null, "积分抵扣", -1)]), 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), paymentType.value === 'wxpay' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "title"
        }, "请使用微信进行扫码支付", -1)), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_unref(codeImg) ? (_openBlock(), _createBlock(_component_vue_qrcode, {
          key: 0,
          value: _unref(codeImg)
        }, null, 8, ["value"])) : _createCommentVNode("", true), _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "scan-line"
        }, null, -1))])])])) : _createCommentVNode("", true), paymentType.value === 'wxpay' ? (_openBlock(), _createElementBlock("p", _hoisted_13, "本次支付金额为：" + _toDisplayString(_unref(buyData).buyMoney) + "元", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("p", null, "当前可用积分：" + _toDisplayString(_unref(amountInfo).availableRechargeBalance), 1), _createElementVNode("p", null, "所需积分：" + _toDisplayString(_unref(buyData).point), 1)]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(handlePointsPayment),
          disabled: !(_unref(amountInfo).availableRechargeBalance > _unref(buyData).point)
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode(" 确认使用积分支付 ")])),
          _: 1
        }, 8, ["onClick", "disabled"])]))])]),
        _: 1
      }, 8, ["modelValue", "onClose"]), _createVNode(_component_el_dialog, {
        modelValue: kfVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => kfVisible.value = $event),
        title: "立即咨询",
        center: "",
        width: "500px"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_image, {
          src: require('@/assets/images/ewcode.png')
        }, null, 8, ["src"]), _createElementVNode("h3", {
          style: {
            "cursor": "pointer"
          },
          onClick: _cache[3] || (_cache[3] = $event => _unref(copyText)('灵泽万川:18666356083'))
        }, _cache[10] || (_cache[10] = [_createTextVNode("咨询电话"), _createElementVNode("i", {
          class: "ri-phone-fill"
        }, null, -1), _createTextVNode("：18666356083 (点击复制)")]))])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});